import React, { useEffect, useState } from "react";
import { Form, Table, Grid, Card } from "tabler-react";
import { Crud_Catalogos } from "../../../herramientas/Crud_Catalogos";
import { NotificationManager } from "react-notifications";
import Select from "react-select";

const CamposLogisticosV2 = ({ accion, elementos }) => {
  const [camposLogisticosPlataforma, setCamposLogisticosPlataforma] = useState([]);
  const [campoLogistico, setCampoLogistico] = useState({ value: 0, label: "Selecciona un campo logistico" });
  const [camposLogisticos, setCamposLogisticos] = useState([]);
  const [idMovimientoTipo, setIdMovimientoTipo] = useState({ value: 0, label: "Selecciona tipo de mov antes de empezar" });
  const [movimientosTipo, setMovimientosTipo] = useState([]);
  const [plataformaCampos, setPlataformaCampos] = useState([]);

  useEffect(() => {
    getfuntion("get", "", "", "plataformasmovimientostipo/plataforma/" + elementos.id, "Movimientostipo");
  }, []);

  useEffect(() => {
    if (idMovimientoTipo.value) {
      getfuntion("get", "", "", "camposLogisticosV2/movimientoTipo/" + idMovimientoTipo.value, "camposLogisticos");
      refresh();
    }
  }, [idMovimientoTipo]);

  const refresh = () => {
    getfuntion("get", "", "", "camposLogisticosV2/plataforma/" + elementos.id + "/mtipo/" + idMovimientoTipo.value, "camposLogisticosPlataforma");
    getfuntion("get", "", "", "plataformaCamposLogisticosV2/plataforma/" + elementos.id + "/movimientoTipo/" + idMovimientoTipo.value, "plataformaCampos");
  };

  const getfuntion = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
    return Crud_Catalogos(catalogo, "plataformas", metodo, id, obj, "", stateVar, hiddenModl, [])
      .then((returnVal) => {
        switch (metodo) {
          case "get":
            if (stateVar === "Movimientostipo") {
              let mtipo = [];
              for (let item of returnVal) {
                mtipo.push({ label: item.idMovimientoTipo.nombre, value: item.idMovimientoTipo.id, data: item.idMovimientoTipo });
              }
              setMovimientosTipo(mtipo);
            }
            if (stateVar === "camposLogisticosPlataforma") {
              setCamposLogisticosPlataforma(returnVal);
            }
            if (stateVar === "camposLogisticos") {
              let camposLogisticosTemp = [];
              for (let item of returnVal) {
                camposLogisticosTemp.push({ value: item.id, label: item.nombre, data: item });
              }
              setCamposLogisticos(camposLogisticosTemp);
            }
            if (stateVar === "plataformaCampos") {
              setPlataformaCampos(
                returnVal.sort(function (a, b) {
                  if (a["orden"] === null) return -1;
                  if (a["orden"] > b["orden"]) return 1;
                  if (a["orden"] < b["orden"]) return -1;
                  return 0;
                })
              );
            }
            break;
          case "post":
            if (stateVar === "plataformaCampos") {
              refresh();
              NotificationManager.info("Nuevo", "Guardado correctamente");
            }
            break;
          case "delete":
            if (stateVar === "plataformaCampos") {
              refresh();
              if (returnVal) NotificationManager.info("Nuevo", "Borrado correctamente");
            }
            break;
          default:
            break;
        }
      })
      .catch((err) => { console.log(err); });
  };

  const agregarCampoLogistico = () => {
    let plataformaCamposTemp = [...plataformaCampos];
    plataformaCamposTemp.push({
      idMovimientoTipo: idMovimientoTipo.value,
      idPlataforma: elementos.id,
      idCamposLogisticos: campoLogistico.value,
      requerido: false,
      orden: plataformaCamposTemp.length + 1,
    });
    setPlataformaCampos(plataformaCamposTemp);
    let camposLogisticosPlataformaTemp = [...camposLogisticosPlataforma];
    camposLogisticosPlataformaTemp.push(campoLogistico.data);
    setCamposLogisticosPlataforma(camposLogisticosPlataformaTemp);
    setCampoLogistico({ value: 0, label: "Selecciona un campo logistico" });
  };

  return (
    <div>
      {accion === "modificar" ? (
        <div>
          <div>
            <div className="form-group">
              <label htmlFor="movTipo">Tipo de Movimiento</label>
              <Select
                value={idMovimientoTipo}
                onChange={(event) => setIdMovimientoTipo(event)}
                options={movimientosTipo}
                isLoading={movimientosTipo.length === 0}
              />
              <small className="form-text text-muted">Para iniciar selecciona tipo de movimiento (Debe estar configurado antes).</small>
            </div>
          </div>
          <div hidden={!idMovimientoTipo.value}>
            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label htmlFor="campo_logistico">Agregar campo logístico</label>
                  <Select
                    value={campoLogistico}
                    onChange={(event) => setCampoLogistico(event)}
                    options={camposLogisticos.filter((cl) => !plataformaCampos.filter((pc) => cl.value === pc.idCamposLogisticos).length)}
                    isLoading={camposLogisticos.length === 0}
                  />
                  <small className="form-text text-muted">Selecciona un campo logístico para agregar.</small>
                </div>
              </div>
              <div className="col-2">
                <div className="form-group">
                  <label htmlFor="campo_logistico_add">Agregar</label>
                  <button
                    type="button" className="btn btn-primary"
                    data-toggle="tooltip" data-placement="top" title={"Agregar Campo logistico a " + idMovimientoTipo.label}
                    onClick={() => agregarCampoLogistico()}
                  >
                    <i className="fa fa-plus" style={{ fontSize: "24px" }}></i>
                  </button>
                </div>
              </div>
              <div className="col-2">
                <div className="form-group">
                  <label htmlFor="campo_logistico_save">Guardar</label>
                  <button
                    type="button" className="btn btn-primary"
                    data-toggle="tooltip" data-placement="top" title={"Guardar cambios"}
                    onClick={() => getfuntion("post", plataformaCampos, "", "plataformaCamposLogisticosV2", "plataformaCampos")}
                  >
                    <i className="fa fa-save" style={{ fontSize: "24px" }}></i>
                  </button>
                </div>
              </div>
            </div>
            <Grid.Row>
              <Grid.Col>
                <Card
                  title="Campos Logísticos V2"
                  isCollapsible={false}
                  isCollapsed={false}
                  body={
                    <div>
                      <Form.Group>
                        <Table cards={true} striped={true} responsive={true} className="table-vcenter">
                          <Table.Header>
                            <Table.ColHeader>ID</Table.ColHeader>
                            <Table.ColHeader>Nombre</Table.ColHeader>
                            <Table.ColHeader>Movimiento Tipo</Table.ColHeader>
                            <Table.ColHeader>Requerido</Table.ColHeader>
                            <Table.ColHeader>Orden</Table.ColHeader>
                            <Table.ColHeader>Remover</Table.ColHeader>
                          </Table.Header>
                          <Table.Body>
                            {plataformaCampos.map((elemento, index) => (
                              <Table.Row key={elemento.id || index}>
                                <Table.Col>{elemento.id}</Table.Col>
                                <Table.Col>
                                  {camposLogisticos.filter((cl) => cl.value === elemento.idCamposLogisticos).length
                                    ? camposLogisticos.filter((cl) => cl.value === elemento.idCamposLogisticos)[0].label
                                    : ""}
                                </Table.Col>
                                <Table.Col>{elemento.idMovimientoTipo}</Table.Col>
                                <Table.Col>
                                  <Form.Switch
                                    type="Checkbox"
                                    name={"req_" + index}
                                    checked={elemento.requerido || false}
                                    onChange={() => {
                                      let plataformaCamposTemp = [...plataformaCampos];
                                      plataformaCamposTemp[index] = { ...elemento, requerido: !elemento.requerido };
                                      setPlataformaCampos(plataformaCamposTemp);
                                    }}
                                  />
                                </Table.Col>
                                <Table.Col>
                                  <div className="row">
                                    <div className="col-6">{elemento.orden}</div>
                                    <div className="col-6">
                                      <div className="col-12" hidden={index < 1}>
                                        <i className="fa fa-caret-up btn" style={{ fontSize: "24px" }}
                                          onClick={() => {
                                            let plataformaCamposTemp = [...plataformaCampos];
                                            let pcTemp = { ...elemento };
                                            pcTemp.orden = index;
                                            plataformaCamposTemp[index] = { ...plataformaCamposTemp[index - 1] };
                                            plataformaCamposTemp[index].orden = index + 1;
                                            plataformaCamposTemp[index - 1] = pcTemp;
                                            setPlataformaCampos(plataformaCamposTemp);
                                          }}></i>
                                      </div>
                                      <div className="col-12" hidden={index >= plataformaCampos.length - 1}>
                                        <i className="fa fa-caret-down btn" style={{ fontSize: "24px" }}
                                          onClick={() => {
                                            let plataformaCamposTemp = [...plataformaCampos];
                                            let pcTemp = { ...elemento };
                                            pcTemp.orden = index + 2;
                                            plataformaCamposTemp[index] = { ...plataformaCamposTemp[index + 1] };
                                            plataformaCamposTemp[index].orden = index + 1;
                                            plataformaCamposTemp[index + 1] = pcTemp;
                                            setPlataformaCampos(plataformaCamposTemp);
                                          }}></i>
                                      </div>
                                    </div>
                                  </div>
                                </Table.Col>
                                <Table.Col>
                                  <i className="fa fa-trash text-danger btn" style={{ fontSize: "24px" }}
                                    data-toggle="tooltip" data-placement="top" title={"Borrar"}
                                    onClick={() => {
                                      if (elemento.id) {
                                        getfuntion("delete", "", elemento.id, "plataformaCamposLogisticosV2", "plataformaCampos");
                                      } else {
                                        let plataformaCamposTemp = [...plataformaCampos];
                                        plataformaCamposTemp.splice(index, 1);
                                        setPlataformaCampos(plataformaCamposTemp);
                                      }
                                    }}
                                  ></i>
                                </Table.Col>
                              </Table.Row>
                            ))}
                          </Table.Body>
                        </Table>
                      </Form.Group>
                    </div>
                  }
                />
              </Grid.Col>
            </Grid.Row>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CamposLogisticosV2;
